var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 74,
    viewBox: "0 0 71 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1414_10328)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.1569,
    cy: 35.1569,
    r: 35.1569,
    fill: "#6A9817"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.1569,
    cy: 35.1569,
    r: 33.6569,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2306 21.0575L47.2308 21.0576C47.7374 21.3398 48.1835 21.7192 48.5438 22.1742C48.9041 22.6292 49.1715 23.1509 49.3306 23.7095C49.4897 24.2682 49.5374 24.8527 49.4709 25.4298C49.4045 26.0069 49.2253 26.5652 48.9435 27.0729L48.9434 27.0731L36.659 49.2247C36.3271 49.823 35.861 50.3359 35.2977 50.723C34.7389 51.107 34.0994 51.3568 33.429 51.4533L32.7841 51.5C31.63 51.4954 30.5119 51.0361 29.6819 50.2024L29.6815 50.202L19.854 40.3568L19.854 40.3567L19.8478 40.3507C19.4262 39.9427 19.0899 39.4547 18.8585 38.9151C18.6271 38.3754 18.5053 37.795 18.5002 37.2076C18.4951 36.6203 18.6068 36.0378 18.8288 35.4942C19.0508 34.9506 19.3786 34.4568 19.7931 34.0416C20.2075 33.6264 20.7003 33.2981 21.2427 33.0758C21.7851 32.8535 22.3662 32.7417 22.9521 32.7468C23.538 32.7519 24.1171 32.8738 24.6555 33.1055C25.194 33.3372 25.681 33.6741 26.0882 34.0964L26.0881 34.0965L26.0943 34.1026L31.3151 39.3329L31.7842 39.8028L32.1063 39.2222L41.2286 22.7758L41.2288 22.7755C41.5101 22.2674 41.8886 21.82 42.3426 21.4587C42.7966 21.0975 43.3172 20.8295 43.8746 20.6699C44.432 20.5104 45.0152 20.4626 45.5911 20.5291C46.1669 20.5956 46.7241 20.7751 47.2306 21.0575Z",
    fill: "white",
    stroke: "#416206"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1414_10328",
    x: 0,
    y: 0,
    width: 70.3125,
    height: 73.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.596078 0 0 0 0 0.0901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1414_10328"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1414_10328",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.bf96043c202454ef9cdabdd53983855d.svg";
export { ForwardRef as ReactComponent };